/**
 * Zip-from-URL hydrator.
 *
 * When the user is redirected cross-domain (e.g. inspiredgo.ca → inspiredgo.com)
 * with a `?cs_zip=...` query param, sessionStorage on the destination origin is
 * empty. This script re-runs the full validation (Zapiet lookup + cart-items
 * region check) on arrival, and only saves the zip to sessionStorage if every
 * gate still passes.
 *
 * URL params are intentionally NOT removed after processing.
 */
(function () {
  'use strict';

  var ZAPIET_SHOP = 'inspiredgo.myshopify.com';

  // location-routing.js region code → local region tag name
  var ROUTING_CODE_TO_REGION = {
    'us_west':    'USA-West',
    'us_west_nv': 'USA-West',
    'us_east':    'USA-East',
    'ca_on':      'toronto',
    'ca_qc':      'quebec',
    'ca_ab':      'calgary',
    'ca_bc':      'calgary',
    'ca_sk':      'calgary',
    'ca_mb':      'calgary'
  };

  function getRegionFromLocId(id) {
    var routing = window.locationRouting;
    if (routing && typeof routing.getRegionFromZapietLocationId === 'function') {
      var code = routing.getRegionFromZapietLocationId(id);
      if (code && ROUTING_CODE_TO_REGION[code]) return ROUTING_CODE_TO_REGION[code];
    }
    return null;
  }

  function validateCartItemsForRegion(resolvedRegion) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return { valid: true };
        var seen = {};
        var handles = [];
        cart.items.forEach(function (item) {
          if (item.handle && !seen[item.handle]) {
            seen[item.handle] = true;
            handles.push(item.handle);
          }
        });
        if (handles.length === 0) return { valid: true };

        var requests = handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) { return { handle: handle, tags: Array.isArray(p.tags) ? p.tags : [] }; });
        });

        // Availability rules: snippets/region-availability.liquid (window.IGRegion)
        return Promise.all(requests).then(function (results) {
          for (var i = 0; i < results.length; i++) {
            if (!window.IGRegion.isAvailableIn(results[i].tags, resolvedRegion)) return { valid: false };
          }
          return { valid: true };
        });
      });
  }

  function syncSidebar(zip, locationId) {
    var sidebar = window.__cartSidebar;
    if (!sidebar) return;
    try {
      sidebar.zapietLocationId = locationId;
      sidebar.zipConfirmedCode = zip;
      if (typeof sidebar.showZipConfirmed === 'function') sidebar.showZipConfirmed(zip);
      if (typeof sidebar.resetCalendar === 'function') sidebar.resetCalendar();
      if (typeof sidebar.saveZipToCart === 'function') sidebar.saveZipToCart(locationId);
      if (typeof sidebar.render === 'function') sidebar.render();
      if (sidebar.currentStep === 2 && sidebar.toggleEl) {
        sidebar.toggleEl.style.display = '';
        if (sidebar.purchaseType === 'subscription' && sidebar.subOptions) {
          sidebar.subOptions.style.display = '';
        }
      }
      if (typeof sidebar.fetchDeliveryOptions === 'function') sidebar.fetchDeliveryOptions(zip);
    } catch (e) {
      console.warn('zip-from-url: sidebar sync error', e);
    }
  }

  function commit(zip, locationId) {
    try {
      sessionStorage.setItem('cs_zip', zip);
      sessionStorage.setItem('cs_location_id', String(locationId));
    } catch (e) {}

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Delivery-Location-Id': String(locationId) } })
    }).catch(function () {});

    try { window.dispatchEvent(new Event('inspiredgo:zip-updated')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cs:zip-confirmed', { detail: { zip: zip, locationId: locationId } })); } catch (e) {}

    var headerInput = document.getElementById('zccPostalCode');
    if (headerInput && !headerInput.value) headerInput.value = zip;

    syncSidebar(zip, locationId);
  }

  function main() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var urlZip = params.get('cs_zip');
    if (!urlZip) return;

    // If sessionStorage already has the same zip, nothing to do.
    var existingZip;
    try { existingZip = sessionStorage.getItem('cs_zip'); } catch (e) {}
    if (existingZip === urlZip) return;

    // Zapiet lookup
    var body = new URLSearchParams();
    body.append('geoSearchQuery', urlZip);
    body.append('shop', ZAPIET_SHOP);

    fetch('https://api.zapiet.com/v1.0/delivery/locations?shop=' + ZAPIET_SHOP, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.error || !res.id) return;

        var resolvedRegion = getRegionFromLocId(res.id);
        if (!resolvedRegion) return;

        return validateCartItemsForRegion(resolvedRegion).then(function (result) {
          if (!result.valid) return;
          commit(urlZip, res.id);
        });
      })
      .catch(function (err) {
        console.warn('zip-from-url: validation error', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
